export const FormInput = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  placeholder = '',
  helperText = '',
  disabled = false
}) => {
  const inputClass = `w-full px-5 py-3 rounded-xl bg-jp-field border border-jp-line text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-jp-accent/40 transition-all${disabled ? ' opacity-60 cursor-not-allowed' : ''}`;

  return (
    <div>
      <label className="block text-left text-jp-ink text-sm font-roboto mb-3">
        {label} {helperText && <span className="text-jp-muted text-xs">{helperText}</span>}
      </label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        className={inputClass}
      />
    </div>
  );
};

export default FormInput;
